var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreValueIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.862 14.636a.748.748 0 00-.13.081l-.01.009-.018.015-.01.008-.013.013-.019.02-.011.01-.012.014-.005.006-.008.01a.726.726 0 00-.17.44v8.159A2.184 2.184 0 000 25.48v7.279c0 .402.326.728.728.728H3.64a.728.728 0 00.728-.728v-7.281c0-.951-.608-1.76-1.456-2.059v-6.934l5.824 3.02v11.596a3.84 3.84 0 001.808 3.257l.002.002c7.53 4.65 15.053 4.633 22.577-.01l.001-.001a3.827 3.827 0 001.808-3.252c.01-3.256.01-10.28.01-11.592l6.887-3.571a.728.728 0 000-1.293L22.174 4.45a.73.73 0 00-.67 0L1.862 14.636zm8.33 5.625V31.1c0 .822.423 1.587 1.12 2.022 7.02 4.334 14.032 4.318 21.045-.01a2.371 2.371 0 001.12-2.015v-.002c.008-2.845.009-8.558.01-10.835l-11.313 5.866a.73.73 0 01-.67 0L10.192 20.26zm-7.28 5.218v6.553H1.456V25.48c0-.402.326-.728.728-.728h.001c.401 0 .727.326.727.727zM5.169 14.56h15.942a.728.728 0 010 1.456H5.17l16.67 8.643 18.074-9.371L21.84 5.917 5.17 14.56z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreValueIcon02);
export default __webpack_public_path__ + "static/media/core-value-icon02.78561b797575b32b9fbf22fb67760cdf.svg";
export { ForwardRef as ReactComponent };